/*
 * DD AdminUI
 * Copyright (C) Fraunhofer IESE 2019 - 2025 Stefan Schweitzer, Shyalan Ramesh, Rafael Aranda López King,
 * Florian Wege, Johannes Schneider, Kazi Rezoanur Rahman, Christoph Müller, Pedram Jokar,
 * Mher Ter-Tovmasyan, Ben Burkhard, Matthias Gerbershagen, Anna Kleiner, Muhammad Tariq,
 * Adeline Silva Schäfer
 *
 * SPDX-License-Identifier: Apache-2.0
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */

import React, { Component } from 'react';
import { connect } from 'react-redux';
import { PlatformAdminUIState, PlatformAdminUIThunkType } from '../../store/store';
import { getNewsSources } from './store/NewsSources.actions';
import NewsSources from './NewsSources.view';
import { RouteComponentProps } from 'react-router-dom';
import { NewsSourcesActionTypes } from './store/NewsSourcesActionTypes';
import { ClientNewsSource } from '@DigitaleDoerfer/digitale-doerfer-api';
import { NEWS_SOURCES_CREATE_URL } from './NewsSourcesRouting.container';

interface Props extends RouteComponentProps {
	clientNewsSource: ClientNewsSource[];
	loading: boolean;
	getNewsSources: () => void;
}

class NewsSourcesContainer extends Component<Props> {
	componentDidMount(): void {
		this.props.getNewsSources();
	}

	createNewsSourcesHandler = (): void => {
		this.props.history.push(NEWS_SOURCES_CREATE_URL);
	};

	render(): JSX.Element {
		const { clientNewsSource, loading } = this.props;
		return (
			<NewsSources
				createNewsSourcesHandler={this.createNewsSourcesHandler}
				clientNewsSource={clientNewsSource}
				loading={loading}
			/>
		);
	}
}

// eslint-disable-next-line @typescript-eslint/explicit-function-return-type
const mapStateToProps = (state: PlatformAdminUIState) => {
	return {
		clientNewsSource: state.newsSource.list.clientNewsSource,
		loading: state.newsSource.list.loading
	};
};

// eslint-disable-next-line @typescript-eslint/explicit-function-return-type
const mapDispatchToProps = (dispatch: PlatformAdminUIThunkType<NewsSourcesActionTypes>) => {
	return {
		getNewsSources: (): Promise<void> => dispatch(getNewsSources())
	};
};

export default connect(mapStateToProps, mapDispatchToProps)(NewsSourcesContainer);
